import React, {useState} from 'react'
import { Card, Container, Row, Col } from 'react-bootstrap'
import dataset from './projects.json'
import ReactPlayer from 'react-player'
import Picmodal from "./PictureModal";




function ProjectDetails(props) {
    // console.log(props)
    const [modalShow, setModalShow] = useState(false);
    const [photoselect, setPhotoSelect] = useState(false);
    window.scrollTo(0, 0)
    const objects = props.projects
    let gridset = objects[props.num].photos.length%3;
    let gridsetvideo = objects[props.num].videos.length%3;
    return (
        <div style={{paddingTop:"20px"}}>
        <Container>
                <br></br>
                <h1>{objects[props.num].Title}</h1>
                {objects[props.num].photos.length>0&&<br></br>}
                <Row style={{display:"flex"}}>
                <Picmodal show={modalShow} onHide={() => setModalShow(false)} image={photoselect}></Picmodal>
                {objects[props.num].photos.length>0&&objects[props.num].photos[0]!==""&&objects[props.num].photos.map((photo,index)=>{
                        // let pic = <img src={photo} alt={objects[props.num].Title} key={index}  style={{marginRight:"0", marginBottom:"10px",alignSelf:"center"}} onClick={() => {setPhotoSelect(photo); setModalShow(true)}}></img>;
                        let pic
                        if (gridset===1&&index<gridset) {
                            pic = <img src={photo} alt={objects[props.num].Title} className=" col-12" key={index}  style={{marginRight:"0", marginBottom:"10px",alignSelf:"center"}} onClick={() => {setPhotoSelect(photo); setModalShow(true)}}></img>
                        }
                        else if (gridset===2&&index<gridset) {
                            pic = <img src={photo} alt={objects[props.num].Title} className=" col-12 col-sm-6" key={index}  style={{marginRight:"0", marginBottom:"10px",alignSelf:"center"}} onClick={() => {setPhotoSelect(photo); setModalShow(true)}}></img>
                        } 
                        else {
                            pic = <img src={photo} alt={objects[props.num].Title} className=" col-12 col-sm-6 col-lg-4" key={index} style={{marginRight:"0", marginBottom:"10px",alignSelf:"center"}} onClick={() => {setPhotoSelect(photo); setModalShow(true)}}></img>
                        }
                        return(
                            // <img src={photo} alt={objects[props.num].Title} className=" col-12 col-sm-6 col-lg-4" key={index}  style={{marginRight:"0", marginBottom:"10px",alignSelf:"center"}} onClick={() => {setPhotoSelect(photo); setModalShow(true)}}></img>
                                pic
                            )
                    })}
                </Row>
                {objects[props.num].videos.length>0&&<br></br>}
                <Row>
                {objects[props.num].videos.length>0&&objects[props.num].videos[0]!==""&&objects[props.num].videos.map((video,index)=>{
                            let vid
                            if (gridsetvideo===1&&index<gridsetvideo) {
                               vid = <ReactPlayer controls url={video} className=" col-12 col-sm-12 col-lg-12" key={index} height="500px" width="100%" style={{marginRight:"0", marginBottom:"10px"}} />
                            }
                            else if (gridsetvideo===2&&index<gridsetvideo) {
                               vid = <ReactPlayer controls url={video} className=" col-12 col-sm-6 col-lg-6" key={index} height="350px" width="100%" style={{marginRight:"0", marginBottom:"10px"}} />
                            } 
                            else {
                               vid = <ReactPlayer controls url={video} className=" col-12 col-sm-6 col-lg-4" key={index} height="200px" width="100px" style={{marginRight:"0", marginBottom:"10px"}} />
                            }
                            return(
                                // <img src={photo} alt={objects[props.num].Title} className=" col-12 col-sm-6 col-lg-4" key={index}  style={{marginRight:"0", marginBottom:"10px",alignSelf:"center"}} onClick={() => {setPhotoSelect(photo); setModalShow(true)}}></img>
                                    vid
                            )
                            // return(
                            //         <ReactPlayer controls url={video} className="col-12" key={index} height="500px" width="90%" style={{marginRight:"0", marginBottom:"10px"}} />
                            // )
                    })}
                </Row>
                <br></br>
                {objects[props.num].data.length>0&&objects[props.num].data.map((obj,index)=>{
                    return(
                        <div key={index}>
                            <h3>{obj.heading+":-"}</h3>
                            <div style={{width:'90%',marginLeft:'40px'}}>
                            {obj.body.length>0&&obj.body.map((bodyobj,index2)=>{
                                return(
                                    <p key={index2}>{bodyobj}</p> 
                                )
                            })}
                            </div>
                        </div>
                    )
                })}
        </Container>
        </div>
    )   

    
}

export default ProjectDetails
